module.exports = __webpack_public_path__ + "static/a-xx-032-art-98b4c156fa38169e703437c797c2b39b.jpg";